// Base64データからimgタグのsrc urlを取得する
export function getFileSrcToBase64(fileData, fileName) {
  if (fileName && fileData) {
    if (getFileType(fileName) === "pdf") {
      return "/img/default-image.4fb5b712.svg";
    } else {
      let fileType = "jpeg";
      if (getFileType(fileName) === "png") fileType = "png";
      return "data:image/" + fileType + ";base64," + fileData;
    }
  }
  return "";
}

export function getFileType(fileName) {
  if (fileName) {
    let extension = fileName.split(".").slice(-1)[0];
    return extension.toLowerCase();
  }
  return "";
}

export function toBlob(base64, mimeCtype) {
  // 日本語の文字化けに対処するためBOMを作成する。
  let bom = new Uint8Array([0xef, 0xbb, 0xbf]);

  let bin = atob(base64.replace(/^.*,/, ""));
  let buffer = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  // Blobを作成
  let blob = "";
  try {
    blob = new Blob([bom, buffer.buffer], { type: mimeCtype });
  } catch (e) {
    return false;
  }
  return blob;
}
